import { Component, inject, input, output, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { BlockConfig, EmptyValuePipe } from '@htx/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatIcon } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-basic-detail-page',
  imports: [
    EmptyValuePipe,
    TranslocoPipe,
    MatIcon,
    MatChipsModule,
    MatButton,
    MatIconButton,
    MatTooltip
  ],
  templateUrl: './basic-detail-page.component.html',
  styleUrl: './basic-detail-page.component.scss'
})
export class BasicDetailPageComponent implements OnInit {
  private readonly clipboard = inject(Clipboard);

  mainTitle = input<string>();
  id = input<string>();
  idLabel = input<string>();
  description = input<SafeHtml>();
  subTitle = input<string>();
  blockConfigs = input<BlockConfig[]>();

  actionButtonClicked = output<string>();

  openSections = new Set<string>();
  copiedKey: string | null = null;

  ngOnInit(): void {
    const configs = this.blockConfigs();
    if (configs) {
      configs.forEach((block) => this.openSections.add(block.title));
    }
  }

  toggleSection(title: string): void {
    if (this.openSections.has(title)) {
      this.openSections.delete(title);
    } else {
      this.openSections.add(title);
    }
  }

  isSectionOpen(title: string): boolean {
    return this.openSections.has(title);
  }

  copyToClipboard(value: string, key: string): void {
    this.clipboard.copy(value);
    this.copiedKey = key;
    setTimeout(() => {
      if (this.copiedKey === key) {
        this.copiedKey = null;
      }
    }, 2000);
  }
}
